import { Building2, HardHat, Home, Warehouse, Wrench } from "lucide-react";
import { Reveal } from "./Reveal";

const SERVICES = [
  {
    icon: Building2,
    title: "Pre-Engineered Metal Buildings",
    copy: "Complete building packages — engineered, supplied, and ready to raise. Clear-span interiors, standing-seam roofs, and steel specced for your wind, snow, and workload.",
    span: "lg:col-span-2",
  },
  {
    icon: HardHat,
    title: "Erecting Services",
    copy: "Already bought a building? Our crew raises it right — anchor bolts to ridge cap, plumb and true.",
    span: "",
  },
  {
    icon: Home,
    title: "Residential Shop Builds",
    copy: "Backyard shops, garages, hobby barns, and barndominiums built for how you actually live and work.",
    span: "",
  },
  {
    icon: Warehouse,
    title: "Commercial Builds",
    copy: "Warehouses, retail bays, ag and industrial facilities — big iron, delivered on schedule.",
    span: "",
  },
  {
    icon: Wrench,
    title: "Options & Upgrades",
    copy: "Insulation packages, overhead and walk-in doors, windows, lean-tos, wainscoting, gutters and more — specced your way.",
    span: "",
  },
];

export const Services = () => (
  <section id="services" data-testid="services-section" className="px-5 py-20 sm:px-8 lg:px-12 lg:py-28">
    <Reveal>
      <p className="text-[11px] font-medium uppercase tracking-[0.4em] text-turquoise">01 — What We Build</p>
      <h2 className="font-heading mt-4 max-w-2xl text-3xl font-black uppercase tracking-tight sm:text-4xl lg:text-5xl">
        Steel for every job, <span className="text-volt">big or small</span>
      </h2>
    </Reveal>

    <div className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
      {SERVICES.map((s, i) => (
        <Reveal key={s.title} delay={i * 0.08} className={s.span}>
          <div
            data-testid={`service-card-${i}`}
            className="group h-full border border-white/10 bg-surface/60 p-8 transition-colors duration-500 hover:border-turquoise/60 lg:p-10"
          >
            <s.icon className="h-8 w-8 text-turquoise transition-colors duration-500 group-hover:text-volt" strokeWidth={1.25} />
            <h3 className="font-heading mt-6 text-xl font-bold uppercase tracking-wide">{s.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-white/60">{s.copy}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
